(function () {
  "use strict";

  const R = window.FTCRenderer;
  const G = window.FTCGiftTemplates;
  const app = document.getElementById("app");
  const mode = app.dataset.variant || document.body.dataset.variant;
  const shopifyMode = app.dataset.shopify === "true";
  const isUS = shopifyMode && app.dataset.country === "US";
  const digitalEnabled = !shopifyMode || app.dataset.digitalEnabled === "true";
  let catalogue = {};
  try { catalogue = JSON.parse(document.getElementById('createProducts')?.textContent || '{}'); } catch (_) { /* Missing catalogue keeps new variants unavailable. */ }
  const frameColors = { black: ['Black','#292a29'], white: ['White','#f5f5f2'], natural: ['Natural wood','#c49c6f'], brown: ['Dark brown','#654735'] };
  function colorsFor(product) { return product === 'framedCanvas' ? ['black','natural','brown'] : product.startsWith('framed') ? ['black','white','natural'] : []; }
  function selectedVariant(product = state.product, color = state.frameColor) {
    if (!colorsFor(product).includes(color)) color = 'black';
    return catalogue[product + (colorsFor(product).length && color !== 'black' ? '_' + color : '')];
  }
  function productPrice(product) {
    const listed = products.find(item => item[0] === product);
    return shopifyMode && Object.keys(catalogue).length ? selectedVariant(product)?.price || 'Unavailable' : (isUS ? listed?.[3] : listed?.[2]) || listed?.[2];
  }
  const shopifyVariants = {
    digital: 54557940580691,
    poster: 54557940154707,
    posterA2: 54557940187475,
    poster5070: 54557940220243,
    canvas: 54557940416851,
    framedA3: 55234267873619,
    framed: 54557940515155,
    framed4050: 54557940547923
  };
  const styles = [
    ["native", "Comment card", "Familiar and clear"],
    ["museum", "Museum", "Quiet and formal"],
    ["poster", "Poster", "Bold and graphic"],
    ["tabloid", "Tabloid", "Loud and playful"]
  ];
  if (mode === "c") styles.push(["screenshot", "Screenshot only", "Original image"]);
  if (mode === "c" && G) G.templates.forEach((t) => styles.push([t.id, t.name, t.description]));
  const products = [
    ["poster", "Poster A3", "EUR 39", "USD 39"],
    ["framedA3", "Framed A3", "EUR 69", "USD 79"],
    ["canvas", "Canvas 30 x 40", "EUR 49", "USD 59"],
    ["framedCanvas", "Framed canvas 30 x 40", "EUR 119", "USD 129"],
    ["digital", "Digital download", "EUR 9", "USD 9"],
    ["framed", "Framed 30 x 40", "EUR 89"],
    ["posterA2", "Poster A2", "EUR 49"],
    ["poster5070", "Poster 50 x 70", "EUR 55"],
    ["framed4050", "Framed 40 x 50", "EUR 129"]
  ].filter(([key]) => key !== "digital" || digitalEnabled);
  const primaryProducts = products.filter(([key]) => ["poster", "framedA3", "canvas", "framedCanvas", "digital"].includes(key));
  const extraProducts = products.filter(([key]) => !primaryProducts.some(([primaryKey]) => primaryKey === key));
  const example = {
    commentText: "This comment has more emotional range than the entire video.",
    authorName: "@framecritic",
    videoTitle: "A very serious video about nothing",
    commentAge: "2 years ago",
    likeCount: "12K"
  };
  const fields = ["sourceUrl", "videoTitle", "communityName", "authorName", "commentAge", "likeCount", "commentText", "accentColor", "editionName", "contextNote"];
  const validStyles = styles.map((item) => item[0]);
  const validProducts = products.map((item) => item[0]);
  const validPlatforms = R.PLATFORM_KEYS;
  const state = {
    entryMode: "comment", platform: "youtube", sourceUrl: "", videoTitle: "", communityName: "",
    authorName: "", commentAge: "", likeCount: "", commentText: "",
    style: "native", product: "poster", frameColor: "black", accentColor: "#ff0033",
    editionName: "Certified comment artifact", contextNote: "", showContext: false,
    showSourceDetails: false, showVideoQr: false,
    screenshotDataUrl: "", screenshotImage: null, screenshotUrl: "", hasScreenshot: false, showGuides: false,
    templateId: "", giftRole: "", giftDate: "", giftExtras: {}, giftPhotoImage: null, hasGiftPhoto: false,
    blankBg: "#FAF7F2", blankFont: "Instrument Serif", blankSize: "M", blankAlign: "center",
    blankPosition: "middle", blankInk: "", blankBorder: false,
    reviewerName: "", reviewSource: "", businessName: "", reviewRating: 5,
    reviewLayout: "text"
  };
  let step = 1;
  let zoom = 1;
  let lastAutoTitle = "";
  let titleTimer = 0;
  let saveTimer = 0;
  let renderQueued = false;
  let qrCacheUrl = "";
  let qrCache = null;
  let ordering = false;
  let screenshotRevision = 0;
  let screenshotLoading = false;
  let reviewOcrJob = null;
  let reviewOcrJobRevision = -1;

  function reviewControls() {
    if (mode !== 'c') return '';
    return `<div id="reviewFields" hidden>
      <div class="review-layout-options" role="group" aria-label="Review layout">
        <button class="choice-button" type="button" data-review-layout="text">Review text</button>
        <button class="choice-button" type="button" data-review-layout="combined">Text + screenshot</button>
        <button class="choice-button" type="button" data-review-layout="screenshot">Screenshot only</button>
      </div>
      <p class="inline-note" id="reviewScreenshotNote" hidden>Your screenshot is printed as uploaded. Crop out full names, profile photos and logos before uploading.</p>
      <div class="field-stack" id="reviewTextDetails"><div class="field-grid">
        ${field('Reviewer first name or initials', 'reviewerName', {max:30, placeholder:'Nina or N. R.'})}
        <label class="field-wrap"><span class="field-label">Star rating</span><select class="field" data-field="reviewRating" aria-label="Star rating">${[5,4,3,2,1].map(n => `<option value="${n}">${n} ${n === 1 ? 'star' : 'stars'}</option>`).join('')}</select></label>
      </div>${field('Source line (optional)', 'reviewSource', {max:60, placeholder:'Google review'})}
      ${field('Business name', 'businessName', {max:80, placeholder:'Your business name'})}
      </div>
      <p class="inline-note">Text layouts show only the first name or initials. Your review text is kept exactly as entered, with no rewriting or added words.</p>
      <p class="quality-warning" id="reviewLengthWarning" role="alert" hidden>This review is longer than 1,200 characters. We have kept all your text. Contact us before ordering so we can help it fit without shortening it.</p>
      <label class="review-permission"><input type="checkbox" id="reviewPermission"> I have permission to reproduce this review and any names or images in my screenshot.</label>
    </div>`;
  }

  function youtubeVideoUrl(raw) {
    try {
      const url = new URL(String(raw || "").trim());
      if (!/^https?:$/.test(url.protocol)) return "";
      const host = url.hostname.toLowerCase();
      const path = url.pathname.split("/").filter(Boolean);
      let id = "";
      if (host === "youtu.be" || host === "www.youtu.be") id = path[0] || "";
      else if (["youtube.com", "www.youtube.com", "m.youtube.com", "music.youtube.com", "youtube-nocookie.com", "www.youtube-nocookie.com"].includes(host)) {
        if (path[0] === "watch") id = url.searchParams.get("v") || "";
        else if (["shorts", "live", "embed"].includes(path[0])) id = path[1] || "";
      }
      return /^[A-Za-z0-9_-]{11}$/.test(id) ? `https://www.youtube.com/watch?v=${id}` : "";
    } catch (_) { return ""; }
  }

  function videoQr() {
    const url = mode === "c" && state.entryMode !== "words" && state.showVideoQr ? youtubeVideoUrl(state.sourceUrl) : "";
    if (!url || !window.qrcode) return null;
    if (url === qrCacheUrl) return qrCache;
    try {
      const code = window.qrcode(0, "M");
      code.addData(url);
      code.make();
      const count = code.getModuleCount();
      const cells = [];
      for (let row = 0; row < count; row += 1) {
        for (let col = 0; col < count; col += 1) cells.push(code.isDark(row, col));
      }
      qrCacheUrl = url;
      qrCache = { count, cells };
      return qrCache;
    } catch (_) { return null; }
  }

  function icon(name) { return `<i data-lucide="${name}" aria-hidden="true"></i>`; }
  function field(label, key, options = {}) {
    const tag = options.multiline ? "textarea" : "input";
    const props = options.multiline
      ? `rows="5" maxlength="600"`
      : `type="${options.type || "text"}" maxlength="${options.max || 90}"`;
    const open = `<${tag} class="field" data-field="${key}" ${props} placeholder="${options.placeholder || ""}">`;
    return `<label class="field-wrap"><span class="field-label">${label}</span>${open}${options.multiline ? "</textarea>" : ""}</label>`;
  }
  function platformPicker() {
    return `<div class="platform-options" role="group" aria-label="Platform">${validPlatforms.map((key) =>
      `<button class="choice-button" type="button" data-platform="${key}" aria-pressed="false">${R.platformFor(key).label}</button>`
    ).join("")}</div>`;
  }
  function screenshotControl() {
    return `<div class="upload-line">
      <label class="small-action upload-button">${icon("image-up")} Add screenshot
        <input id="screenshotInput" type="file" accept="image/png,image/jpeg,image/webp" hidden>
      </label>
      <span class="upload-status" id="uploadStatus">Optional</span>
      <button class="text-action" id="readReviewScreenshot" type="button" hidden>Read text from image</button>
      <button class="text-action" id="removeScreenshot" type="button" hidden>Remove</button>
    </div><p class="status" id="ocrStatus" role="status" aria-live="polite"></p>`;
  }
  function entryModePicker() {
    if (mode !== "c") return "";
    return `<div class="entry-mode"><h2>What are you framing?</h2>
      <div class="entry-mode-options" role="group" aria-label="What are you framing?">
        <button type="button" data-entry-mode="comment" aria-pressed="true">Online comment<small>Link or screenshot</small></button>
        <button type="button" data-entry-mode="words" aria-pressed="false">Words to gift<small>No post needed</small></button>
        <button type="button" data-entry-mode="review" aria-pressed="false">Review<small>For your business wall</small></button>
      </div>
      <a class="small-action studio-entry" data-studio-link href="${shopifyMode ? "/pages/create-from-scratch" : "../create-studio/index.html"}">${icon("sliders-horizontal")} Start from scratch</a>
      <nav class="gift-shortcuts" id="giftShortcuts" aria-label="Gift ideas" hidden>
        <span>Gift ideas</span><a href="/pages/gifts-for-dad">For Dad</a><a href="/pages/teacher-gifts">For a teacher</a><a href="/pages/leaving-gifts">For a colleague</a><a href="/pages/wedding-anniversary-gifts">Wedding &amp; anniversary</a><a href="/pages/kids-quotes">Kids' quotes</a><a href="/pages/business-gifts">Business</a>
      </nav>
    </div>`;
  }
  function contentFields() {
    return `<div class="field-stack">
      <div id="commentInputField">${field("Your comment", "commentText", { multiline: true, placeholder: "Paste the comment here" })}</div>
      ${reviewControls()}
      ${mode === "c" ? `<div id="giftCreditField" hidden>${field("From (optional)", "authorName", { max: 40, placeholder: "A name or short credit" })}</div>` : ""}
      ${mode === "c" && G ? `<div id="giftTemplateFields" class="gift-fields" hidden></div>` : ""}
      <div class="source-row" id="sourceRow">
        <div id="sourceUrlField">${field("Link to the post or video", "sourceUrl", { type: "url", max: 500, placeholder: "https://youtube.com/..." })}</div>
        ${screenshotControl()}
      </div>
      ${mode === "c" ? `<div class="qr-option" id="qrOption"><label class="upload-line"><input type="checkbox" data-toggle="showVideoQr" disabled> Add QR code to YouTube video</label><span class="qr-hint" id="videoQrHint" hidden>Use a YouTube video link for the QR code.</span></div>` : ""}
      <button class="text-action sample-button" type="button" id="useSample">Try an example instead</button>
    </div>`;
  }
  function detailFields() {
    return `<details class="more-fields" id="detailFields"><summary>Add name, title and other details</summary>
      <div class="field-stack">
        <div class="field-grid">
          ${field("Comment author", "authorName", { max: 40, placeholder: "@name" })}
          ${field("Post or video title", "videoTitle", { placeholder: "What was it about?" })}
        </div>
        <div class="field-grid">
          ${field("When posted", "commentAge", { max: 20, placeholder: "2 years ago" })}
          ${field("Likes / points", "likeCount", { max: 12, placeholder: "12K" })}
        </div>
        <div id="communityField" hidden>${field("Subreddit", "communityName", { max: 30, placeholder: "r/videos" })}</div>
        <div class="field-grid">
          <label class="field-wrap"><span class="field-label">Accent colour</span><input class="field" data-field="accentColor" type="color" value="#ff0033"></label>
          ${mode === "c" ? "" : field("Edition line", "editionName", { max: 36, placeholder: "Certified comment artifact" })}
        </div>
        ${mode === "c" ? "" : `<label class="upload-line"><input type="checkbox" data-toggle="showContext"> Add a small context line to the artwork</label>
        <div id="contextNoteField" hidden>${field("Context line", "contextNote", { max: 120, placeholder: "A little extra context" })}</div>`}
      </div>
    </details>`;
  }
  function stylePicker(visual) {
    if (visual) {
      const commentStyles = styles.filter(([key]) => !G?.byId[key]);
      const giftStyles = styles.filter(([key]) => G?.byId[key]);
      const choices = (items) => items.map(([key, name, description]) =>
        `<button class="visual-style" type="button" ${key === "blank" ? 'data-studio-entry="true"' : `data-style="${key}" aria-pressed="false"`}><canvas data-style-preview="${key}" width="200" height="250" aria-hidden="true"></canvas><span>${name}</span><small>${description}</small></button>`
      ).join("");
      return `<div class="visual-style-grid" id="commentStyles" role="group" aria-label="Comment treatments">${choices(commentStyles)}</div>${G ? `<div class="gift-style-section" id="giftStyles" hidden><h3>Gift templates</h3><div class="visual-style-grid" role="group" aria-label="Gift templates">${choices(giftStyles)}</div></div>` : ""}`;
    }
    return `<div class="style-options" role="group" aria-label="Artwork style">${styles.map(([key, name]) =>
      `<button class="choice-button" type="button" data-style="${key}" aria-pressed="false">${name}</button>`
    ).join("")}</div>`;
  }
  function productPicker() {
    function options(items) {
      return items.map(([key, name]) => `<button class="choice-button product-button" type="button" data-product="${key}" aria-pressed="false"><span class="format-scene" aria-hidden="true"><span class="format-art" data-format-art="${key}"><canvas data-product-preview="${key}" width="160" height="220"></canvas></span></span><span>${name}</span><strong data-price="${key}"></strong></button>`).join("");
    }
    return `<div class="product-options${primaryProducts.length === 3 ? " is-three" : ""}" role="group" aria-label="Product">${options(primaryProducts)}</div><div id="frameOptions" class="frame-options" hidden><span class="field-label">Frame colour</span><div role="group" aria-label="Frame colour">${Object.entries(frameColors).map(([key,[name,color]])=>`<button type="button" class="frame-swatch" data-frame-color="${key}" aria-pressed="false"><span style="--swatch:${color}" aria-hidden="true"></span>${name}</button>`).join('')}</div></div><p class="inline-note" id="digitalNote" hidden>Clean 2400 x 3000 px PNG. Prepared individually and emailed after payment, not an instant download. No shipping.</p>${isUS && !Object.keys(catalogue).length ? "" : `
      <button type="button" class="text-action more-products" id="moreProducts" aria-expanded="false">More sizes</button>
      <div class="product-options product-options-extra" id="extraProducts" hidden>${options(extraProducts)}</div>`}`;
  }
  function actions() {
    return `<div class="action-row">
      ${shopifyMode ? `<button class="primary-action" type="button" id="orderBtn">${icon("shopping-bag")} Order</button>` : ""}
      <button class="primary-action" type="button" id="downloadBtn">${icon("download")} Download preview</button>
      ${!shopifyMode && mode === "c" ? `<button class="outline-action" type="button" id="printFileBtn">${icon("download")} Export full-size file</button>` : ""}
      <button class="outline-action" type="button" id="copyBtn">${icon("link")} ${shopifyMode ? "Copy design link" : "Copy test link"}</button>
    </div><div class="purchase-details"><p id="productInclusions"></p><p id="purchaseDelivery"></p><a href="${shopifyMode ? '/pages/print-guide' : 'https://framethiscomment.com/pages/print-guide'}">Sizes &amp; materials</a> <span aria-hidden="true">&middot;</span> <a href="${shopifyMode ? '/pages/shipping' : 'https://framethiscomment.com/pages/shipping'}">Shipping &amp; returns</a></div><p class="error-line" id="formError" role="alert" aria-live="polite"></p>`;
  }
  function header() {
    if (shopifyMode) return "";
    return `<header class="site-header"><a class="wordmark" href="./index.html">FRAME<span>THIS</span>COMMENT<span class="wordmark-dot">.</span></a>
      <nav class="variant-nav" aria-label="Create concepts">
        <a href="./a.html" data-variant-link="a" ${mode === "a" ? 'aria-current="page"' : ""}>A · Direct</a>
        <a href="./b.html" data-variant-link="b" ${mode === "b" ? 'aria-current="page"' : ""}>B · Guided</a>
        <a href="./c.html" data-variant-link="c" ${mode === "c" ? 'aria-current="page"' : ""}>C · Visual</a>
      </nav></header>`;
  }
  function preview() {
    return `<aside class="proof-side" aria-label="Live artwork preview"><div class="proof-sticky">
      <div class="proof-head"><div><strong>Your artwork</strong><br><span id="previewState" class="sample-flag">Example preview</span></div>
        <div class="zoom-control" aria-label="Preview zoom">
          <button class="icon-button" type="button" id="zoomOut" title="Zoom out" aria-label="Zoom out">${icon("minus")}</button>
          <span class="zoom-value" id="zoomValue">Fit</span>
          <button class="icon-button" type="button" id="zoomIn" title="Zoom in" aria-label="Zoom in">${icon("plus")}</button>
          <button class="icon-button" type="button" id="zoomFit" title="Fit preview" aria-label="Fit preview">${icon("scan")}</button>
        </div>
      </div>
      <div class="preview-stage" id="previewStage"><div class="art-shell" id="artShell"><canvas id="previewCanvas" width="400" height="560" role="img" aria-label="Artwork preview"></canvas></div></div>
      <div class="preview-footer"><div><strong id="productName">Poster A3</strong><small id="productSize">297 x 420 mm</small></div><strong class="price" id="productPrice">EUR 39</strong></div>
      <p class="quality-warning" id="qualityWarning" role="status" hidden></p>
    </div></aside>`;
  }
  function directPage() {
    return `<section class="work-side"><div class="work-inner">
      <div class="intro"><p class="kicker">Create · A / Direct editor</p><h1>Make a comment into art.</h1><p>Start with the words. Everything else can come later.</p></div>
      <div class="section"><div class="section-head"><h2>1. The comment</h2></div>${contentFields()}${detailFields()}</div><div id="mobilePreviewAnchor"></div>
      <div class="section"><div class="section-head"><h2>2. Where was it posted?</h2></div>${platformPicker()}</div>
      <div class="section"><div class="section-head"><h2>3. Pick the look</h2></div>${stylePicker(false)}</div>
      <div class="section"><div class="section-head"><h2>4. Pick the print</h2></div>${productPicker()}${actions()}</div>
    </div></section>`;
  }
  function guidedPage() {
    return `<section class="work-side"><div class="work-inner">
      <div class="intro"><p class="kicker">Create · B / Guided</p><h1>One step at a time.</h1></div>
      <nav class="step-meter" aria-label="Progress"><button type="button" data-go-step="1" aria-label="Step 1: comment"></button><button type="button" data-go-step="2" aria-label="Step 2: style"></button><button type="button" data-go-step="3" aria-label="Step 3: print"></button></nav><div id="mobilePreviewAnchor"></div>
      <div class="step-panel" data-step="1"><span class="step-counter">Step 1 of 3</span><h2>Which comment?</h2><p>Paste the text or add a screenshot. You can fix anything we read.</p>
        ${contentFields()}<div class="section"><div class="section-head"><h2>Platform</h2></div>${platformPicker()}</div>${detailFields()}</div>
      <div class="step-panel" data-step="2" hidden><span class="step-counter">Step 2 of 3</span><h2>Choose a style.</h2><p>Each option uses your comment. Select the one that feels right.</p>${stylePicker(true)}</div>
      <div class="step-panel" data-step="3" hidden><span class="step-counter">Step 3 of 3</span><h2>Choose your print.</h2><p>Check the artwork and choose a size.</p>${productPicker()}
        <ul class="review-list" id="reviewList"></ul>${actions()}</div>
      <p class="error-line" id="stepError" role="alert" aria-live="polite"></p>
      <div class="step-controls"><button class="outline-action" type="button" id="backStep" hidden>Back</button><button class="primary-action" type="button" id="nextStep">Next ${icon("arrow-right")}</button></div>
    </div></section>`;
  }
  function visualPage() {
    return `<section class="work-side"><div class="work-inner">
      <div class="intro"><p class="kicker">${shopifyMode ? "Create your print" : "Create · C / Visual compare"}</p><h1 id="createHeading">Find the frame for your comment.</h1><p id="createIntro">See each treatment before making the final call.</p></div>
      <div class="section">${entryModePicker()}${contentFields()}<div id="contextOptions"><div class="optional-context" id="contextNoteField">${field("Extra text or context (optional)", "contextNote", { max: 120, placeholder: "What makes this comment funny?" })}</div><label class="upload-line source-toggle"><input type="checkbox" data-toggle="showSourceDetails"> Include source details</label></div>${detailFields()}</div>
      <div class="section" id="platformSection"><div class="section-head"><h2>Platform</h2></div>${platformPicker()}</div>
      <div class="section" id="styleSection"><div class="section-head"><h2 id="styleHeading">Choose a treatment</h2></div>${stylePicker(true)}</div><div id="mobilePreviewAnchor"></div>
      <div class="section"><div class="section-head"><h2>Choose your format</h2></div>${productPicker()}<p class="quality-warning quality-warning-order" id="printQualityWarning" role="alert" hidden></p>${shopifyMode ? `<label class="quality-confirm" id="qualityConfirm" hidden><input id="qualityConfirmInput" type="checkbox"> I understand this screenshot may print blurry at this size.</label>` : ""}${actions()}</div>
    </div></section>`;
  }

  app.innerHTML = header() + `<main class="workspace">${mode === "b" ? guidedPage() : mode === "c" ? visualPage() : directPage()}${preview()}</main>`;
  if (window.lucide) window.lucide.createIcons();

  function openStudio() {
    const image = state.entryMode === "words" ? state.giftPhotoImage?.src || "" : "";
    const payload = { app: "FrameThisComment Studio", version: 1, design: {
      title: state.videoTitle || "", text: state.commentText || "", author: state.authorName || "",
      detail: state.giftRole || "", date: state.giftDate || "", note: state.contextNote || "", link: state.sourceUrl || "", showQr: !!state.showVideoQr,
      product: state.product,
      frameColor: state.frameColor,
      hasPhoto: !!image || (state.entryMode === "words" && state.hasGiftPhoto), photoName: state.giftPhotoFile?.name || "",
      ...(state.templateId === "blank" ? { background: state.blankBg, font: state.blankFont, ink: state.blankInk || "#1a1a1a", align: state.blankAlign, position: state.blankPosition, border: state.blankBorder ? "line" : "none", fontSize: state.blankSize === "L" ? 115 : state.blankSize === "S" ? 66 : 88 } : {})
    } };
    const url = new URL(shopifyMode ? "/pages/create-from-scratch" : "../create-studio/index.html", location.href);
    if (image) {
      const handoff = crypto.randomUUID();
      try { sessionStorage.setItem("ftc-studio-entry:" + handoff, image); url.searchParams.set("handoff", handoff); } catch (_) { /* Studio requests the original when storage is full. */ }
    }
    const params = new URLSearchParams(location.search);
    for (const key of ["utm_source", "utm_medium", "utm_campaign", "preview_theme_id"]) if (params.has(key)) url.searchParams.set(key, params.get(key));
    url.hash = btoa(String.fromCharCode(...new TextEncoder().encode(JSON.stringify(payload))));
    location.href = url.href;
  }
  document.querySelector("[data-studio-link]")?.addEventListener("click", event => { event.preventDefault(); openStudio(); });

  function fillTemplate(id, force) {
    const template = G?.byId[id];
    if (!template) return;
    const previous = G.byId[state.templateId];
    const stillExample = !state.commentText.trim() || state.commentText === previous?.quote;
    if (force || stillExample) state.commentText = template.quote;
    if (force || !state.authorName.trim() || state.authorName === previous?.nameExample) state.authorName = template.nameExample;
    if (force || !state.giftRole || state.giftRole === previous?.role) state.giftRole = template.role;
    if (force || !state.giftDate || state.giftDate === previous?.date) state.giftDate = template.date;
    const nextExtras = {};
    template.extras.forEach(([key, , example]) => {
      const oldExample = previous?.extras.find(row => row[0] === key)?.[2];
      nextExtras[key] = !force && state.giftExtras[key] !== undefined && state.giftExtras[key] !== oldExample ? state.giftExtras[key] : example;
    });
    state.giftExtras = nextExtras;
    state.templateId = id;
    state.style = id;
    state.entryMode = "words";
  }
  function renderGiftFields() {
    const container = document.getElementById("giftTemplateFields");
    if (!container || !G) return;
    const template = G.byId[state.templateId || state.style];
    container.hidden = !template || state.entryMode !== "words";
    if (!template) return;
    const extras = template.extras.map(([key, label]) => `<label class="field-wrap"><span class="field-label">${label}</span><input class="field" data-gift-extra="${key}" maxlength="120"></label>`).join("");
    const photo = template.photo ? `<div class="gift-photo-control"><label class="small-action upload-button">${icon("image-up")} ${template.id === "gift-13b" ? "Add logo" : "Add photo"}<input id="giftPhotoInput" type="file" accept="image/png,image/jpeg,image/webp" hidden></label><span id="giftPhotoStatus">Optional · JPG or PNG</span><button class="text-action" id="removeGiftPhoto" type="button" ${state.giftPhotoImage ? "" : "hidden"}>Remove</button><p>Your image is used only to make and print this poster, never for marketing or AI training.</p></div>` : "";
    const blank = template.id === "blank" ? `<div class="blank-controls"><label class="field-wrap"><span class="field-label">Background</span><select class="field" data-gift-option="blankBg">${G.palettes.map(color => `<option value="${color}">${color}</option>`).join("")}</select></label><label class="field-wrap"><span class="field-label">Font</span><select class="field" data-gift-option="blankFont">${G.fonts.map(name => `<option>${name}</option>`).join("")}</select></label><label class="field-wrap"><span class="field-label">Size</span><select class="field" data-gift-option="blankSize"><option>S</option><option>M</option><option>L</option></select></label><label class="field-wrap"><span class="field-label">Alignment</span><select class="field" data-gift-option="blankAlign"><option>left</option><option>center</option><option>right</option></select></label><label class="field-wrap"><span class="field-label">Position</span><select class="field" data-gift-option="blankPosition"><option>top</option><option>middle</option><option>bottom</option></select></label><label class="upload-line"><input type="checkbox" data-gift-option="blankBorder"> Add fine border</label></div>` : "";
    container.innerHTML = `<div class="gift-field-grid">${field("Name", "authorName", { max: 48 })}${field("Age or role", "giftRole", { max: 48 })}${field("Date or occasion", "giftDate", { max: 48 })}${extras}</div>${photo}${blank}<p class="gift-length-hint" id="giftLengthHint" hidden>Short quotes look best on the wall.</p>`;
    container.querySelectorAll("[data-field]").forEach(control => { control.value = state[control.dataset.field] || ""; });
    container.querySelectorAll("[data-gift-extra]").forEach(control => { control.value = state.giftExtras[control.dataset.giftExtra] ?? ""; });
    container.querySelectorAll("[data-gift-option]").forEach(control => {
      if (control.type === "checkbox") control.checked = !!state[control.dataset.giftOption];
      else control.value = state[control.dataset.giftOption];
    });
    container.querySelector("#giftPhotoInput")?.addEventListener("change", loadGiftPhoto);
    document.getElementById("giftLengthHint").hidden = state.commentText.length <= 52;
    if (window.lucide) window.lucide.createIcons();
  }
  async function loadGiftPhoto(event) {
    const file = event.target.files?.[0];
    if (!file) return;
    if (!/^image\/(png|jpeg|webp)$/.test(file.type)) { setError("Choose a JPG, PNG or WebP image."); return; }
    const dataUrl = await readFile(file);
    const image = new Image();
    image.onload = () => {
      state.giftPhotoImage = image;
      state.giftPhotoFile = file;
      state.hasGiftPhoto = true;
      document.getElementById("giftPhotoStatus").textContent = file.name;
      document.getElementById("removeGiftPhoto").hidden = false;
      scheduleRender();
    };
    image.onerror = () => setError("Could not open this image. Try a JPG or PNG.");
    image.src = dataUrl;
  }

  const proofSide = document.querySelector(".proof-side");
  const workspace = document.querySelector(".workspace");
  const mobileAnchor = document.getElementById("mobilePreviewAnchor");
  function placePreview() {
    if (window.innerWidth <= 1060 && mode === "b") {
      document.querySelector(`.step-panel[data-step="${step}"]`).after(proofSide);
    } else if (window.innerWidth <= 1060) mobileAnchor.after(proofSide);
    else workspace.append(proofSide);
  }
  placePreview();

  function readHash() {
    try {
      const raw = location.hash.slice(1);
      if (!raw) return;
      const bytes = Uint8Array.from(atob(raw), (char) => char.charCodeAt(0));
      const parsed = JSON.parse(new TextDecoder().decode(bytes));
      fields.forEach((key) => { if (typeof parsed[key] === "string") state[key] = parsed[key]; });
      if (validPlatforms.includes(parsed.platform)) state.platform = parsed.platform;
      if (["words", "review"].includes(parsed.entryMode)) state.entryMode = parsed.entryMode;
      if (validStyles.includes(parsed.style)) state.style = parsed.style;
      if (validProducts.includes(parsed.product)) state.product = parsed.product;
      if (frameColors[parsed.frameColor]) state.frameColor = parsed.frameColor;
      if (typeof parsed.showContext === "boolean") state.showContext = parsed.showContext;
      if (typeof parsed.showSourceDetails === "boolean") state.showSourceDetails = parsed.showSourceDetails;
      if (typeof parsed.showVideoQr === "boolean") state.showVideoQr = parsed.showVideoQr;
      if (typeof parsed.hasScreenshot === "boolean") state.hasScreenshot = parsed.hasScreenshot;
      if (isShopifyFileUrl(parsed.screenshotUrl)) { state.screenshotUrl = parsed.screenshotUrl; state.hasScreenshot = true; }
      if (G && G.byId[parsed.templateId]) state.templateId = parsed.templateId;
      for (const key of ["giftRole", "giftDate", "blankBg", "blankFont", "blankSize", "blankAlign", "blankPosition", "blankInk"]) {
        if (typeof parsed[key] === "string") state[key] = parsed[key];
      }
      if (parsed.giftExtras && typeof parsed.giftExtras === "object" && !Array.isArray(parsed.giftExtras)) {
        state.giftExtras = Object.fromEntries(Object.entries(parsed.giftExtras).filter(([key, val]) => /^[a-z]+$/.test(key) && typeof val === "string").map(([key, val]) => [key, val.slice(0, 120)]));
      }
      if (typeof parsed.blankBorder === "boolean") state.blankBorder = parsed.blankBorder;
      if (typeof parsed.hasGiftPhoto === "boolean") state.hasGiftPhoto = parsed.hasGiftPhoto;
      if (parsed.entryMode === 'review') {
        state.businessName = String(parsed.businessName || '').slice(0,80);
        // Older paid designs can still recover their selected review, without a bundle UI.
        const old = Array.isArray(parsed.reviews) ? parsed.reviews[Number(parsed.reviewIndex) || 0] : null;
        if (old) state.commentText = String(old.text || '');
        state.reviewerName = R.reviewCredit(old?.reviewer ?? parsed.reviewerName).slice(0,30);
        state.reviewSource = String(old?.source ?? parsed.reviewSource ?? '').slice(0,60);
        state.reviewRating = Math.max(1,Math.min(5,Math.round(Number(old?.rating ?? parsed.reviewRating)||5)));
        if (['text','combined','screenshot'].includes(parsed.reviewLayout)) state.reviewLayout = parsed.reviewLayout;
      }
    } catch (_) { /* An invalid link opens a fresh design. */ }
  }
  readHash();
  if (!location.hash && mode === 'c' && new URLSearchParams(location.search).get('mode') === 'review') {
    state.entryMode = 'review';
  }
  if (state.entryMode === 'review') {
    if (state.product === 'digital') state.product = 'poster';
    state.style = 'museum'; state.templateId = '';
    state.hasGiftPhoto = false;
    state.showVideoQr = false; state.showSourceDetails = false; state.showContext = false;
  }
  const requestedProduct = new URLSearchParams(location.search).get('product');
  if (!location.hash && validProducts.includes(requestedProduct)) state.product = requestedProduct;
  const requestedVariant = new URLSearchParams(location.search).get('variant');
  const requestedEntry = requestedVariant && Object.entries(catalogue).find(([,value]) => String(value.id) === requestedVariant);
  if (!location.hash && requestedEntry) {
    const [product,color='black'] = requestedEntry[0].split('_');
    if (validProducts.includes(product)) { state.product = product; state.frameColor = color; }
  }
  if (state.entryMode === 'review' && state.product === 'digital') state.product = 'poster';
  if (!colorsFor(state.product).includes(state.frameColor) && colorsFor(state.product).length) state.frameColor = 'black';
  if (isUS && !Object.keys(catalogue).length && !products.find(([key, , , usd]) => key === state.product && usd)) state.product = "poster";
  const requestedTemplate = new URLSearchParams(location.search).get("template");
  if (mode === "c" && G && G.byId[requestedTemplate]) fillTemplate(requestedTemplate, !state.templateId);
  else if (mode === "c" && G && G.byId[state.style]) state.templateId = state.style;
  else if (mode === "c" && state.entryMode === "words" && G) fillTemplate("gift-03", !location.hash);
  if (mode === "c" && state.entryMode === "words") {
    if (!G && (state.style === "native" || state.style === "screenshot")) state.style = "museum";
    state.showVideoQr = false;
  }
  if (mode === "c" && state.contextNote.trim()) state.showContext = true;
  try {
    const stored = sessionStorage.getItem("ftc-concept-screenshot");
    if (!state.screenshotUrl && stored && (!location.hash || state.hasScreenshot)) {
      state.screenshotDataUrl = stored;
      const image = new Image();
      image.onload = () => { state.screenshotImage = image; scheduleRender(); };
      image.src = stored;
    }
  } catch (_) { /* Private browsing can disable storage. */ }
  if (state.screenshotUrl) {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => { state.screenshotImage = image; scheduleRender(); };
    image.onerror = () => setOcrStatus('Could not load the saved screenshot. Upload the original again before ordering or exporting.', true);
    image.src = state.screenshotUrl;
  }

  function encodeState() {
    const payload = {};
    fields.forEach((key) => { payload[key] = state[key]; });
    payload.platform = state.platform;
    payload.entryMode = state.entryMode;
    payload.style = state.style;
    payload.product = state.product;
    payload.frameColor = state.frameColor;
    payload.showContext = state.showContext;
    payload.showSourceDetails = state.showSourceDetails;
    payload.showVideoQr = state.showVideoQr;
    payload.hasScreenshot = state.entryMode !== "words" && (state.hasScreenshot || !!state.screenshotImage);
    if (payload.hasScreenshot && isShopifyFileUrl(state.screenshotUrl)) payload.screenshotUrl = state.screenshotUrl;
    if (G && state.entryMode === "words") {
      for (const key of ["templateId", "giftRole", "giftDate", "giftExtras", "blankBg", "blankFont", "blankSize", "blankAlign", "blankPosition", "blankInk", "blankBorder"]) payload[key] = state[key];
      payload.hasGiftPhoto = !!state.giftPhotoImage || state.hasGiftPhoto;
    }
    if (state.entryMode === "words") {
      for (const key of ["sourceUrl", "videoTitle", "communityName", "commentAge", "likeCount"]) payload[key] = "";
      payload.showSourceDetails = false;
      payload.showVideoQr = false;
    }
    if (state.entryMode === 'review') {
      Object.assign(payload, {reviewLayout:state.reviewLayout, businessName:state.businessName,
        reviewerName:R.reviewCredit(state.reviewerName), reviewSource:state.reviewSource, reviewRating:Number(state.reviewRating),
        showSourceDetails:false, showVideoQr:false, showContext:false,
        authorName:'',sourceUrl:'',videoTitle:'',communityName:'',commentAge:'',likeCount:''});
    }
    return encodePayload(payload);
  }
  function encodePayload(payload) {
    const bytes = new TextEncoder().encode(JSON.stringify(payload));
    let binary = "";
    bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
    return btoa(binary);
  }
  function saveState() {
    const hash = "#" + encodeState();
    document.querySelectorAll("[data-variant-link]").forEach((link) => {
      link.href = `./${link.dataset.variantLink}.html${hash}`;
    });
    clearTimeout(saveTimer);
    saveTimer = setTimeout(() => {
      try { history.replaceState(null, "", hash); } catch (_) { /* file URLs vary by browser. */ }
    }, 120);
  }
  function writeFields() {
    document.querySelectorAll("[data-field]").forEach((control) => { control.value = state[control.dataset.field] || ""; });
    if (mode === "c") {
      const words = state.entryMode === "words";
      const review = state.entryMode === 'review';
      workspace.dataset.entryMode = state.entryMode;
      const sourceRow = document.getElementById('sourceRow');
      sourceRow.parentElement.insertBefore(sourceRow,document.getElementById(review ? 'commentInputField' : 'qrOption'));
      const text = document.querySelector('#commentInputField [data-field="commentText"]');
      document.querySelector("#commentInputField .field-label").textContent = review ? 'Review text' : words ? "Words to frame" : "Your comment";
      text.placeholder = review ? 'Paste the exact customer review here' : words ? "Type the words here" : "Paste the comment here";
      if (review) text.removeAttribute('maxlength');
      else text.maxLength = 600;
      document.querySelector("#contextNoteField .field-label").textContent = words ? "Small note (optional)" : "Extra text or context (optional)";
      document.getElementById("createHeading").textContent = review ? 'Frame your best review.' : words ? "Frame the words worth keeping." : "Find the frame for your comment.";
      document.getElementById("createIntro").textContent = review ? 'Your customers said it best. Give their words a place on your wall.' : words ? "Make a personal print, with or without an online post." : "See each treatment before making the final call.";
      if (G) renderGiftFields();
    }
    const toggle = document.querySelector('[data-toggle="showContext"]');
    if (toggle) toggle.checked = !!state.showContext;
    const sourceToggle = document.querySelector('[data-toggle="showSourceDetails"]');
    if (sourceToggle) sourceToggle.checked = !!state.showSourceDetails;
    const qrToggle = document.querySelector('[data-toggle="showVideoQr"]');
    if (qrToggle) qrToggle.checked = !!state.showVideoQr;
    if (mode !== "c") document.getElementById("contextNoteField").hidden = !state.showContext;
    document.getElementById("communityField").hidden = state.platform !== "reddit";
  }
  function selectedStates() {
    document.querySelectorAll("[data-platform]").forEach((button) => button.setAttribute("aria-pressed", button.dataset.platform === state.platform));
    document.querySelectorAll("[data-style]").forEach((button) => button.setAttribute("aria-pressed", button.dataset.style === state.style));
    document.querySelectorAll("[data-product]").forEach((button) => button.setAttribute("aria-pressed", button.dataset.product === state.product));
    const colors = colorsFor(state.product);
    if (colors.length && !colors.includes(state.frameColor)) state.frameColor = 'black';
    document.getElementById('frameOptions').hidden = !colors.length;
    document.querySelectorAll('[data-frame-color]').forEach(button => {
      button.hidden = !colors.includes(button.dataset.frameColor);
      button.setAttribute('aria-pressed', button.dataset.frameColor === state.frameColor);
    });
    document.querySelectorAll('[data-price]').forEach(label => { label.textContent = productPrice(label.dataset.price); });
    document.getElementById("digitalNote").hidden = state.product !== "digital";
    document.getElementById("communityField").hidden = state.platform !== "reddit";
    if (mode !== "c") document.getElementById("contextNoteField").hidden = !state.showContext;
    if (mode === "c") {
      const words = state.entryMode === "words";
      const review = state.entryMode === 'review';
      document.querySelectorAll("[data-entry-mode]").forEach((button) => button.setAttribute("aria-pressed", button.dataset.entryMode === state.entryMode));
      document.getElementById("giftShortcuts").hidden = !words;
      document.getElementById("giftCreditField").hidden = !words || !!G;
      if (G) {
        document.getElementById("commentStyles").hidden = words;
        document.getElementById("giftStyles").hidden = !words;
        document.getElementById("styleHeading").textContent = words ? "Choose a gift template" : "Choose a treatment";
        document.getElementById("giftTemplateFields").hidden = !words;
      }
      document.getElementById("sourceRow").hidden = words;
      document.getElementById("qrOption").hidden = words;
      document.querySelector(".source-toggle").hidden = words;
      for (const key of ["native", "screenshot"]) document.querySelector(`[data-style="${key}"]`).hidden = words;
      const videoUrl = youtubeVideoUrl(state.sourceUrl);
      const qrToggle = document.querySelector('[data-toggle="showVideoQr"]');
      qrToggle.disabled = !videoUrl || !window.qrcode;
      if (qrToggle.disabled) state.showVideoQr = false;
      qrToggle.checked = state.showVideoQr;
      document.getElementById("videoQrHint").hidden = !state.sourceUrl.trim() || !!videoUrl;
      const screenshotOnly = state.style === "screenshot";
      const screenshotButton = document.querySelector('[data-style="screenshot"]');
      screenshotButton.disabled = !state.screenshotImage && state.style !== "screenshot";
      screenshotButton.title = state.screenshotImage ? "Print the original image" : "Add a screenshot first";
      for (const id of ["commentInputField", "useSample", "contextOptions", "detailFields", "platformSection"]) {
        document.getElementById(id).hidden = screenshotOnly || (words && ["detailFields", "platformSection"].includes(id));
      }
      document.querySelector(".source-row").classList.toggle("screenshot-only", screenshotOnly);
      const copy = document.getElementById("copyBtn");
      copy.hidden = screenshotOnly || (shopifyMode && !words && state.hasScreenshot);
      document.getElementById("ocrStatus").hidden = screenshotOnly;
      document.getElementById('reviewFields').hidden = !review;
      document.getElementById('reviewLengthWarning').hidden = !review || state.reviewLayout === 'screenshot' || state.commentText.length <= 1200;
      document.getElementById('styleSection').hidden = review;
      document.querySelector('.studio-entry').hidden = review;
      if (review) {
        for (const id of ['qrOption','contextOptions','detailFields','platformSection','useSample','giftTemplateFields','giftCreditField','sourceUrlField']) document.getElementById(id).hidden = true;
        document.getElementById('sourceRow').hidden = false;
        document.getElementById('commentInputField').hidden = state.reviewLayout === 'screenshot';
        document.getElementById('reviewTextDetails').hidden = state.reviewLayout === 'screenshot';
      }
      document.getElementById('sourceUrlField').hidden = review;
      document.getElementById('readReviewScreenshot').hidden = !review || !state.screenshotImage;
      document.getElementById('readReviewScreenshot').disabled = !!reviewOcrJob;
      document.getElementById('readReviewScreenshot').textContent = reviewOcrJob ? 'Reading text...' : 'Read text from image';
      document.getElementById('reviewFields').setAttribute('aria-busy',String(review && !!reviewOcrJob));
      document.getElementById('reviewScreenshotNote').hidden = !review || (!state.hasScreenshot && !state.screenshotImage);
      document.querySelectorAll('[data-review-layout]').forEach(button => {
        button.setAttribute('aria-pressed',button.dataset.reviewLayout === state.reviewLayout);
        button.disabled = button.dataset.reviewLayout !== 'text' && !state.screenshotImage;
        button.title = button.disabled ? 'Add a screenshot first' : '';
      });
      document.querySelectorAll('[data-product]').forEach(button => { button.hidden = review && button.dataset.product === 'digital'; });
      const more = document.getElementById('moreProducts'); if (more) more.hidden = false;
    }
    if ((!isUS || Object.keys(catalogue).length) && extraProducts.some(([key]) => key === state.product)) {
      document.getElementById("extraProducts").hidden = false;
      document.getElementById("moreProducts").setAttribute("aria-expanded", "true");
      document.getElementById("moreProducts").textContent = "Fewer sizes";
    }
  }
  function renderModel(style) {
    if (state.entryMode === 'review') return {...state, commentText:state.commentText || (reviewOcrJob ? 'Reading your review...' : 'Your customer review goes here.'), reviewerName:R.reviewCredit(state.reviewerName), screenshotImage:state.reviewLayout === 'text' ? null : state.screenshotImage, screenshotOnly:state.reviewLayout === 'screenshot', giftPhotoImage:null, videoQr:null, templateId:'', style:'museum'};
    const chosenStyle = style || state.style;
    const screenshotOnly = mode === "c" && chosenStyle === "screenshot";
    const words = mode === "c" && state.entryMode === "words";
    const exampleMetadata = mode !== "c" || (!state.commentText.trim() && !words);
    return {
      ...state,
      templateId: G?.byId[chosenStyle] ? chosenStyle : "",
      plainCredit: words,
      sourceUrl: words ? "" : state.sourceUrl,
      screenshotImage: words ? null : state.screenshotImage,
      screenshotLayout: mode === "c" ? "separate" : "overlay",
      screenshotOnly,
      videoQr: videoQr(),
      quietFooter: mode === "c",
      showSourceDetails: mode === "c" ? !words && state.showSourceDetails : true,
      showContext: mode === "c" ? !screenshotOnly && ((!words && state.showSourceDetails) || !!state.contextNote.trim()) : state.showContext,
      style: screenshotOnly ? "native" : chosenStyle,
      commentText: state.commentText.trim() || (words ? G?.byId[state.templateId]?.quote || "The words we keep become part of us." : example.commentText),
      authorName: state.authorName.trim() || (exampleMetadata ? example.authorName : ""),
      videoTitle: state.videoTitle.trim() || (exampleMetadata ? example.videoTitle : ""),
      commentAge: state.commentAge.trim() || (exampleMetadata ? example.commentAge : ""),
      likeCount: state.likeCount.trim() || (exampleMetadata ? example.likeCount : "")
    };
  }
  function imagePrintQuality(product) {
    if (state.product === "digital") return null;
    const giftImage = state.entryMode === "words" && G?.byId[state.templateId]?.photo ? state.giftPhotoImage : null;
    const screenshot = (state.entryMode === "comment" || state.entryMode === 'review' && state.reviewLayout !== 'text') && state.screenshotImage;
    const image = giftImage || screenshot;
    if (!image) return null;
    const width = image.naturalWidth || image.width;
    const height = image.naturalHeight || image.height;
    const usableW = product.trim[0] - product.safe * 2;
    const usableH = product.trim[1] - product.safe * 2;
    let scale = screenshot && (state.style === "screenshot" || state.entryMode === 'review')
      ? Math.min(usableW / width, usableH / height)
      : giftImage && state.templateId === "gift-13b" ? usableW * .24 / width
      : Math.max(usableW / width, usableH / height);
    if (screenshot && state.entryMode === 'review' && state.reviewLayout === 'combined') {
      const [fullW,fullH] = R.exportSize(state.product);
      const margin = Math.max(fullW * .095, product.bleed + product.safe);
      const boxW = fullW - margin * 2;
      const boxH = Math.min((fullH - margin * 2) * .28, boxW * .6);
      scale = Math.min(boxW / width, boxH / height);
    }
    const dpi = Math.round(300 / scale);
    if (dpi >= 150) return null;
    const name = products.find((item) => item[0] === state.product)[1];
    return dpi < 100
      ? { level: "low", message: `This image is too small and will look blurry when printed on ${name} (about ${dpi} dpi).` }
      : { level: "caution", message: `This image may print slightly soft at this size (about ${dpi} dpi on ${name}).` };
  }
  function drawArtwork(ctx, model, width, height) {
    if (G?.byId[model.templateId]) G.renderArtwork(ctx, model, width, height);
    else R.renderArtwork(ctx, model, width, height);
  }
  function render() {
    renderQueued = false;
    selectedStates();
    const canvas = document.getElementById("previewCanvas");
    const stage = document.getElementById("previewStage");
    stage.classList.toggle("is-zoomed", zoom > 1);
    const shell = document.getElementById("artShell");
    const product = R.productFor(state.product);
    const canvasProduct = ['canvas','framedCanvas'].includes(state.product);
    const ratio = canvasProduct ? product.trim[0] / product.trim[1] : R.aspectRatio(state.product);
    const reserve = ['frame','floating-frame'].includes(product.mockup) ? 90 : 54;
    const maxWidth = Math.max(150, stage.clientWidth - reserve);
    const maxHeight = Math.max(220, stage.clientHeight - reserve);
    const width = Math.min(maxWidth, maxHeight * ratio) * zoom;
    const height = width / ratio;
    const dpr = Math.min(devicePixelRatio || 1, 2);
    canvas.style.width = `${Math.round(width)}px`;
    canvas.style.height = `${Math.round(height)}px`;
    canvas.width = Math.max(1, Math.round(width * dpr));
    canvas.height = Math.max(1, Math.round(height * dpr));
    shell.dataset.mockup = product.mockup;
    shell.style.setProperty('--frame-colour', frameColors[state.frameColor][1]);
    if (canvasProduct) R.renderTrimPreview(canvas.getContext('2d'), state.product, canvas.width, canvas.height, (ctx,w,h) => drawArtwork(ctx,renderModel(),w,h));
    else drawArtwork(canvas.getContext("2d"), renderModel(), canvas.width, canvas.height);
    const livePreview = state.style === "screenshot" || state.entryMode === 'review' && state.reviewLayout === 'screenshot' ? !!state.screenshotImage : !!state.commentText.trim();
    document.getElementById("previewState").textContent = livePreview ? "Live preview" : "Example preview";
    document.getElementById("previewState").classList.toggle("sample-flag", !livePreview);
    document.getElementById("zoomValue").textContent = zoom === 1 ? "Fit" : `${Math.round(zoom * 100)}%`;
    const listed = products.find((item) => item[0] === state.product);
    document.getElementById("productName").textContent = listed[1];
    document.getElementById("productPrice").textContent = productPrice(state.product);
    const orderButton = document.getElementById('orderBtn');
    if (orderButton && Object.keys(catalogue).length) orderButton.disabled = ordering || !selectedVariant()?.available;
    document.getElementById("productSize").textContent = product.sizeNote.split(" · ")[0];
    document.getElementById('productInclusions').textContent = productInclusions(state.product);
    document.getElementById('purchaseDelivery').textContent = state.product === 'digital'
      ? 'Prepared individually and emailed after payment, not an instant download. No shipping.'
      : app.dataset.deliveryNote || 'Made to order. Delivery estimate and shipping total are shown at checkout.';
    document.querySelectorAll('[data-product-preview]').forEach(thumb => {
      const key = thumb.dataset.productPreview, format = R.productFor(key);
      const model = {...renderModel(), product:key};
      const isCanvas = ['canvas','framedCanvas'].includes(key);
      thumb.width = 160;
      thumb.height = Math.round(160 / (isCanvas ? format.trim[0] / format.trim[1] : R.aspectRatio(key)));
      const art = thumb.parentElement;
      art.dataset.mockup = format.mockup;
      const color = colorsFor(key).includes(state.frameColor) ? state.frameColor : 'black';
      art.style.setProperty('--frame-colour', frameColors[color][1]);
      if (isCanvas) R.renderTrimPreview(thumb.getContext('2d'), key, thumb.width, thumb.height, (ctx,w,h) => drawArtwork(ctx,model,w,h));
      else drawArtwork(thumb.getContext('2d'), model, thumb.width, thumb.height);
    });
    document.querySelectorAll("[data-style-preview]").forEach((thumb) => {
      if (thumb.dataset.stylePreview === "screenshot" && !state.screenshotImage) {
        const context = thumb.getContext("2d");
        context.fillStyle = "#f0f3f1";
        context.fillRect(0, 0, thumb.width, thumb.height);
        context.fillStyle = "#597371";
        context.textAlign = "center";
        context.font = "700 15px sans-serif";
        context.fillText("ADD SCREENSHOT", thumb.width / 2, thumb.height / 2);
        return;
      }
      drawArtwork(thumb.getContext("2d"), renderModel(thumb.dataset.stylePreview), thumb.width, thumb.height);
    });
    const quality = imagePrintQuality(product);
    for (const id of ["qualityWarning", "printQualityWarning"]) {
      const warning = document.getElementById(id);
      if (!warning) continue;
      warning.hidden = !quality;
      if (quality) {
        warning.dataset.level = quality.level;
        warning.textContent = quality.message;
      } else {
        delete warning.dataset.level;
        warning.textContent = "";
      }
    }
    if (shopifyMode) {
      document.getElementById("qualityConfirm").hidden = quality?.level !== "low";
      document.querySelector("#qualityConfirm").lastChild.textContent = " I understand this image may print blurry at this size.";
    }
    if (G && mode === "c") document.getElementById("giftLengthHint")?.toggleAttribute("hidden", state.entryMode !== "words" || state.commentText.length <= 52);
    if (mode === "b") updateReview();
    saveState();
  }
  function scheduleRender() {
    if (renderQueued) return;
    renderQueued = true;
    requestAnimationFrame(render);
  }
  function productInclusions(key) {
    const size = ['canvas','framedCanvas'].includes(key) ? '30 x 40 cm' : R.productFor(key).sizeNote.split(' · ')[0];
    if (key === 'digital') return 'Clean 2400 x 3000 px PNG. No watermark. No physical item.';
    if (key === 'framedCanvas') return `${size} canvas, floating wooden frame and hanging kit. No glazing.`;
    if (key.startsWith('framed')) return `${size} print, wooden frame, acrylic glazing and hanging kit. Arrives assembled.`;
    if (key === 'canvas') return `${size} stretched canvas, 2 cm profile and hanging kit. No outer frame.`;
    return `${size} print on 200 gsm matte paper. Frame not included.`;
  }
  function updateReview() {
    const list = document.getElementById("reviewList");
    if (!list) return;
    const product = products.find((item) => item[0] === state.product);
    const style = styles.find((item) => item[0] === state.style);
    list.innerHTML = `<li><span>Comment</span><strong></strong></li><li><span>Style</span><strong></strong></li><li><span>Print</span><strong></strong></li>`;
    const values = [state.commentText.trim() || "Add a comment", style[1], `${product[1]} · ${product[2]}`];
    list.querySelectorAll("strong").forEach((node, index) => { node.textContent = values[index]; });
  }
  function showStep() {
    if (mode !== "b") return;
    document.querySelectorAll(".step-panel").forEach((panel) => { panel.hidden = Number(panel.dataset.step) !== step; });
    document.querySelectorAll("[data-go-step]").forEach((button) => {
      const value = Number(button.dataset.goStep);
      button.classList.toggle("is-active", value === step);
      button.classList.toggle("is-done", value < step);
      button.setAttribute("aria-current", value === step ? "step" : "false");
    });
    document.getElementById("backStep").hidden = step === 1;
    document.getElementById("nextStep").hidden = step === 3;
    document.getElementById("stepError").textContent = "";
    if (step === 3) updateReview();
    placePreview();
  }
  function setError(message) {
    const node = document.getElementById("formError") || document.getElementById("stepError");
    if (node) node.textContent = message;
  }
  function clearError() {
    document.querySelectorAll(".error-line").forEach((node) => { node.textContent = ""; });
  }

  document.addEventListener("input", (event) => {
    const extra = event.target.dataset.giftExtra;
    if (extra) { state.giftExtras[extra] = event.target.value; scheduleRender(); return; }
    const key = event.target.dataset.field;
    if (!key) return;
    state[key] = event.target.value;
    if (state.entryMode === 'review') {
      document.getElementById('reviewPermission').checked = false;
    }
    if (mode === "c" && key === "contextNote") state.showContext = !!state.contextNote.trim();
    if (key === "sourceUrl") {
      detectPlatform();
      clearTimeout(titleTimer);
      titleTimer = setTimeout(fetchYouTubeTitle, 700);
    }
    clearError();
    scheduleRender();
  });
  document.addEventListener("change", (event) => {
    const giftOption = event.target.dataset.giftOption;
    if (giftOption) {
      state[giftOption] = event.target.type === "checkbox" ? event.target.checked : event.target.value;
      scheduleRender();
      return;
    }
    if (["showContext", "showSourceDetails", "showVideoQr"].includes(event.target.dataset.toggle)) {
      state[event.target.dataset.toggle] = event.target.checked;
      scheduleRender();
    }
  });
  document.addEventListener("click", (event) => {
    const button = event.target.closest("button");
    if (!button) return;
    if (button.dataset.studioEntry) { openStudio(); return; }
    if (button.dataset.entryMode && mode === "c") {
      const previousMode = state.entryMode;
      state.entryMode = button.dataset.entryMode;
      if (state.entryMode === 'review') {
        if (state.product === 'digital') state.product = 'poster';
        state.style = 'museum'; state.templateId = '';
        state.showVideoQr = false; state.hasGiftPhoto = false;
        document.getElementById('reviewPermission').checked = false;
      } else if (state.entryMode === "words") {
        if (G && !G.byId[state.style]) fillTemplate("gift-03", !state.commentText.trim());
        else if (!G && (state.style === "native" || state.style === "screenshot")) state.style = "museum";
        state.showVideoQr = false;
      } else if (G?.byId[state.style]) {
        state.style = "native";
        state.templateId = "";
      }
      if (previousMode === 'review' && state.entryMode !== 'review') {
        state.commentText = ''; state.style = 'native'; state.templateId = '';
        if (state.entryMode === 'words' && G) fillTemplate('gift-03',true);
      }
      writeFields();
      scheduleRender();
    }
    if (button.dataset.reviewLayout) {
      state.reviewLayout = button.dataset.reviewLayout;
      document.getElementById('reviewPermission').checked = false;
      if (shopifyMode) document.getElementById('qualityConfirmInput').checked = false;
      clearError(); scheduleRender();
      if (state.reviewLayout !== 'screenshot' && !state.commentText.trim() && state.screenshotImage) requestReviewText();
    }
    if (button.dataset.platform) {
      const oldAccent = state.accentColor.toLowerCase();
      state.platform = button.dataset.platform;
      if (validPlatforms.some((key) => R.platformFor(key).accent.toLowerCase() === oldAccent)) {
        state.accentColor = R.platformFor(state.platform).accent;
        document.querySelector('[data-field="accentColor"]').value = state.accentColor;
      }
      scheduleRender();
    }
    if (button.dataset.style) {
      if (button.dataset.style === "screenshot" && !state.screenshotImage) return;
      if (G?.byId[button.dataset.style]) { fillTemplate(button.dataset.style, false); writeFields(); }
      else state.style = button.dataset.style;
      if (shopifyMode) document.getElementById("qualityConfirmInput").checked = false;
      scheduleRender();
    }
    if (button.dataset.product) {
      state.product = button.dataset.product;
      if (shopifyMode) document.getElementById("qualityConfirmInput").checked = false;
      scheduleRender();
    }
    if (button.dataset.frameColor && colorsFor(state.product).includes(button.dataset.frameColor)) {
      state.frameColor = button.dataset.frameColor;
      scheduleRender();
    }
    if (button.id === "moreProducts") {
      const extra = document.getElementById("extraProducts");
      extra.hidden = !extra.hidden;
      button.setAttribute("aria-expanded", String(!extra.hidden));
      button.textContent = extra.hidden ? "More sizes" : "Fewer sizes";
    }
    if (button.id === "useSample") {
      if (state.entryMode === "words" && G) fillTemplate(state.templateId || "gift-03", true);
      else Object.entries(example).forEach(([key, value]) => { state[key] = value; });
      writeFields();
      clearError();
      scheduleRender();
    }
    if (button.id === "zoomIn") { zoom = Math.min(1.9, Math.round((zoom + .15) * 100) / 100); scheduleRender(); }
    if (button.id === "zoomOut") { zoom = Math.max(.55, Math.round((zoom - .15) * 100) / 100); scheduleRender(); }
    if (button.id === "zoomFit") { zoom = 1; scheduleRender(); }
    if (button.id === "nextStep") {
      if (step === 1 && !state.commentText.trim()) {
        setError("Add a comment first, or try the example.");
        document.querySelector('[data-field="commentText"]').focus();
      } else if (step < 3) {
        step += 1; showStep();
      }
    }
    if (button.id === "backStep" && step > 1) { step -= 1; showStep(); }
    if (button.dataset.goStep) {
      const target = Number(button.dataset.goStep);
      if (target > 1 && !state.commentText.trim()) { setError("Add a comment first."); return; }
      step = target; showStep();
    }
    if (button.id === "downloadBtn") downloadPreview();
    if (button.id === "printFileBtn") exportPrintFile();
    if (button.id === "orderBtn") orderDesign(button);
    if (button.id === "copyBtn") copyDesignLink(button);
    if (button.id === "removeScreenshot") removeScreenshot();
    if (button.id === 'readReviewScreenshot' && (screenshotInput.files?.[0] || state.screenshotImage)) {
      if (state.reviewLayout === 'screenshot') state.reviewLayout = 'combined';
      requestReviewText(); scheduleRender();
    }
    if (button.id === "removeGiftPhoto") {
      state.giftPhotoImage = null; state.giftPhotoFile = null; state.hasGiftPhoto = false;
      document.getElementById("giftPhotoInput").value = "";
      document.getElementById("giftPhotoStatus").textContent = "Optional · JPG or PNG";
      button.hidden = true;
      scheduleRender();
    }
  });

  function detectPlatform() {
    let host = "";
    try { host = new URL(state.sourceUrl).hostname.toLowerCase(); } catch (_) { return; }
    const matches = (domain) => host === domain || host.endsWith("." + domain);
    const next = matches("reddit.com") ? "reddit" : matches("tiktok.com") ? "tiktok" : matches("instagram.com") ? "instagram" : matches("youtube.com") || matches("youtu.be") ? "youtube" : null;
    if (!next || next === state.platform) return;
    const oldAccent = state.accentColor.toLowerCase();
    state.platform = next;
    if (validPlatforms.some((key) => R.platformFor(key).accent.toLowerCase() === oldAccent)) {
      state.accentColor = R.platformFor(next).accent;
      document.querySelector('[data-field="accentColor"]').value = state.accentColor;
    }
    scheduleRender();
  }
  async function fetchYouTubeTitle() {
    const url = state.sourceUrl.trim();
    let host = "";
    try { host = new URL(url).hostname.toLowerCase(); } catch (_) { return; }
    if (!(host === "youtube.com" || host.endsWith(".youtube.com") || host === "youtu.be")) return;
    try {
      const response = await fetch("https://www.youtube.com/oembed?format=json&url=" + encodeURIComponent(url));
      if (!response.ok) return;
      const data = await response.json();
      if (state.sourceUrl.trim() !== url || !data.title) return;
      if (!state.videoTitle.trim() || state.videoTitle === lastAutoTitle) {
        state.videoTitle = String(data.title).slice(0, 90);
        lastAutoTitle = state.videoTitle;
        document.querySelector('[data-field="videoTitle"]').value = state.videoTitle;
        scheduleRender();
      }
    } catch (_) { /* Other platforms and blocked metadata remain editable. */ }
  }

  const screenshotInput = document.getElementById("screenshotInput");
  screenshotInput.addEventListener("change", async () => {
    const file = screenshotInput.files && screenshotInput.files[0];
    if (!file) return;
    if (!/^image\/(png|jpeg|webp)$/.test(file.type)) { setOcrStatus("Choose a PNG, JPG or WebP image.", true); return; }
    const revision = ++screenshotRevision;
    screenshotLoading = true;
    try {
      const dataUrl = await readFile(file);
      const image = new Image();
      await new Promise((resolve,reject) => { image.onload = resolve; image.onerror = reject; image.src = dataUrl; });
      if (revision !== screenshotRevision) return;
      state.screenshotImage = image;
      screenshotLoading = false;
      state.screenshotDataUrl = dataUrl;
      state.screenshotUrl = '';
      state.hasScreenshot = true;
      if (state.entryMode === 'review') {
        state.reviewLayout = 'screenshot';
        document.getElementById('reviewPermission').checked = false;
      }
      if (shopifyMode) document.getElementById("qualityConfirmInput").checked = false;
      try { sessionStorage.setItem("ftc-concept-screenshot", dataUrl); } catch (_) { /* Large images may exceed session storage. */ }
      document.getElementById("uploadStatus").textContent = file.name;
      document.getElementById("removeScreenshot").hidden = false;
      scheduleRender();
      if (state.entryMode === 'review') setOcrStatus('Screenshot added. You can print the original image or read its text and check it first.');
      else { setOcrStatus("Reading text from screenshot..."); await readScreenshot(file); }
    } catch (_) { if(revision === screenshotRevision){ screenshotLoading = false; setOcrStatus("Could not open this image. Try another screenshot.", true); } }
  });
  function readFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ""));
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }
  function setOcrStatus(message, isError) {
    const node = document.getElementById("ocrStatus");
    node.textContent = message;
    node.classList.toggle("error", !!isError);
  }
  function removeScreenshot() {
    screenshotRevision++; screenshotLoading = false;
    state.screenshotDataUrl = "";
    state.screenshotUrl = '';
    state.screenshotImage = null;
    state.hasScreenshot = false;
    if (state.style === "screenshot") state.style = "native";
    if (state.entryMode === 'review') {
      state.reviewLayout = 'text';
      document.getElementById('reviewPermission').checked = false;
    }
    screenshotInput.value = "";
    document.getElementById("uploadStatus").textContent = "Optional";
    document.getElementById("removeScreenshot").hidden = true;
    setOcrStatus("");
    try { sessionStorage.removeItem("ftc-concept-screenshot"); } catch (_) { /* No storage. */ }
    scheduleRender();
  }
  async function readScreenshot(file) {
    const revision = screenshotRevision;
    const entryMode = state.entryMode;
    if (!window.Tesseract) { setOcrStatus(entryMode === 'review' ? 'The text reader is unavailable. Type your review above, or try again.' : "Text recognition is unavailable here. You can type the comment above.", true); return; }
    try {
      const review = state.entryMode === 'review';
      setOcrStatus('Reading text from screenshot...');
      const result = await window.Tesseract.recognize(file, "eng+nld");
      const raw = result && result.data ? result.data.text : "";
      if (revision !== screenshotRevision || entryMode !== state.entryMode) return;
      if (review) {
        if (state.entryMode !== 'review') return;
        if (!state.commentText.trim()) state.commentText = String(raw).trim();
        document.getElementById('reviewPermission').checked = false;
        writeFields(); scheduleRender();
        setOcrStatus(state.commentText.trim() ? 'Text ready. Please check it against the image and remove any names or buttons that do not belong to the review.' : 'No clear text found. Type your review above, or try Read text from image again.', !state.commentText.trim());
        return;
      }
      const parsed = parseOcr(raw);
      if (parsed.commentText && !state.commentText.trim()) state.commentText = parsed.commentText;
      for (const key of ["authorName", "commentAge", "likeCount", "videoTitle", "communityName"]) {
        if (parsed[key] && !state[key].trim()) state[key] = parsed[key];
      }
      if (parsed.platform && !state.sourceUrl.trim()) state.platform = parsed.platform;
      writeFields();
      scheduleRender();
      setOcrStatus(parsed.commentText ? "Text found. Please check and correct it." : "Could not read a clear comment. Please type it above.", !parsed.commentText);
    } catch (_) {
      if (revision !== screenshotRevision || entryMode !== state.entryMode) return;
      setOcrStatus(entryMode === 'review' ? 'Could not read the image. Type your review above, or try Read text from image again.' : "Text recognition failed. Please type the comment above.", true);
    }
  }
  function requestReviewText() {
    if (reviewOcrJob && reviewOcrJobRevision === screenshotRevision) return reviewOcrJob;
    if (state.commentText.trim()) {
      setOcrStatus('Your text has been kept. You can edit it above; the screenshot is unchanged.');
      return Promise.resolve();
    }
    const file = screenshotInput.files?.[0] || state.screenshotImage;
    if (!file) return Promise.resolve();
    reviewOcrJobRevision = screenshotRevision;
    const job = readScreenshot(file).finally(() => { if(reviewOcrJob === job){ reviewOcrJob = null; scheduleRender(); } });
    reviewOcrJob = job;
    scheduleRender();
    return reviewOcrJob;
  }
  function parseOcr(raw) {
    const chrome = /^(reply|replies|beantwoorden|antwoorden|reageren|share|delen|save|opslaan|subscribe|abonneren|sort by|sorteren op|add a comment|reactie toevoegen|view all|view replies|show more|read more|meer weergeven|lees meer|like|likes|vind ik leuk|dislike|translate|see translation|vertalen|hq|hd|sd|uhd|hdr|cc)$/i;
    const trailing = /\s+(reply|replies|beantwoorden|antwoorden|reageren|share|delen|show more|read more|meer weergeven|lees meer|like|likes|vind ik leuk|hq|hd|sd|uhd|hdr|cc)$/i;
    const action = /(?:^|\s)(reply|replies|beantwoorden|antwoorden|reageren|share|delen)$/i;
    const lines = [];
    for (const rawLine of String(raw || "").split(/\r?\n/)) {
      let clean = rawLine.replace(/\s+/g, " ").trim();
      const prefix = clean.replace(action, "").trim();
      const iconRow = action.test(clean) && (
        !prefix || (/^[^\s]{1,3}(?:\s+[^\s]{1,3}){0,3}$/.test(prefix) && /[^a-z\s]/i.test(prefix))
      );
      if (iconRow && lines.length) break;
      while (trailing.test(clean)) clean = clean.replace(trailing, "").trim();
      if (clean && !chrome.test(clean)) lines.push(clean);
    }
    const joined = lines.join("\n").toLowerCase();
    const platform = joined.includes("reddit.com") || /\br\//.test(joined) ? "reddit" : joined.includes("tiktok.com") ? "tiktok" : joined.includes("instagram.com") ? "instagram" : "youtube";
    const authorIndex = lines.findIndex((line) => /(?:^|\s)(@[\w.-]{2,}|u\/[\w.-]{2,})/i.test(line));
    const authorMatch = authorIndex >= 0 ? lines[authorIndex].match(/(?:^|\s)(@[\w.-]{2,}|u\/[\w.-]{2,})/i) : null;
    const ageMatch = joined.match(/\b\d+\s*(?:sec|seconds?|minutes?|hours?|days?|weeks?|months?|years?|seconden?|minu(?:ut|ten)|uren?|dagen?|weken?|maanden?|jaren?)\s*(?:ago|geleden)?\b/i);
    const scoreMatch = joined.match(/\b(\d[\d.,]*\s*[km]?)\s*(?:likes?|points?|votes?|upvotes?|vind ik leuk|punten|stemmen)\b/i);
    const title = authorIndex > 0 ? lines.slice(0, authorIndex).find((line) => line.length > 9 && !/^(@|u\/|r\/)/.test(line)) : "";
    const afterAuthor = authorIndex >= 0 ? lines.slice(authorIndex + 1) : lines;
    const commentLines = [];
    for (const line of afterAuthor) {
      if (scoreMatch && line.toLowerCase().includes(scoreMatch[0].toLowerCase())) break;
      if (chrome.test(line) || (ageMatch && line.toLowerCase() === ageMatch[0].toLowerCase())) continue;
      if (line.length > 1 && line !== title) commentLines.push(line);
    }
    return {
      platform,
      videoTitle: title ? title.slice(0, 90) : "",
      communityName: (joined.match(/\br\/[\w.-]{2,}/i) || [""])[0],
      authorName: authorMatch ? authorMatch[1] : "",
      commentAge: ageMatch ? ageMatch[0] : "",
      likeCount: scoreMatch ? scoreMatch[1].replace(/\s+/g, "") : "",
      commentText: (commentLines.join(" ") || lines.slice().sort((a, b) => b.length - a.length)[0] || "").slice(0, 600)
    };
  }

  function ensureComment() {
    if (screenshotLoading) { setError('Please wait until the screenshot has finished loading.'); return false; }
    if (state.entryMode === 'review') {
      if (state.reviewLayout !== 'text' && !state.screenshotImage) { setError('Upload your review screenshot first.'); return false; }
      if (state.reviewLayout === 'screenshot') return true;
      if (state.commentText.length > 1200) { setError('We have kept your complete review. Contact us for reviews longer than 1,200 characters.'); return false; }
      if (!state.commentText.trim()) { setError('Add your review text, or choose Screenshot only.'); return false; }
    }
    if (mode === "c" && state.style === "screenshot" && state.screenshotImage) return true;
    if (state.commentText.trim()) return true;
    setError(state.entryMode === "words" ? "Add the words you want to frame first." : "Add a comment first, or try the example.");
    if (mode === "b") { step = 1; showStep(); }
    document.querySelector('[data-field="commentText"]').focus();
    return false;
  }
  function canvasBlob(canvas, type, quality) {
    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error("Could not create the print file on this device.")), type, quality);
    });
  }
  function isShopifyFileUrl(value) {
    try {
      const url = new URL(value);
      return url.protocol === "https:" && url.hostname === "cdn.shopify.com" && url.pathname.includes("/uploads/");
    } catch (_) { return false; }
  }
  async function orderDesign(button) {
    if (!shopifyMode || ordering) return;
    if (app.dataset.previewOnly === 'true') { setError('Preview only. Ordering is disabled; the live shop has not changed.'); return; }
    const review = state.entryMode === 'review';
    if (review) {
      if (state.product === 'digital') { setError('Choose a physical print for this review.'); return; }
      if (state.reviewLayout !== 'screenshot' && (!state.reviewerName.trim() || !state.businessName.trim())) { setError('Add the reviewer first name or initials and your business name.'); return; }
      if (!document.getElementById('reviewPermission').checked) { setError('Please confirm you have permission to reproduce this review and screenshot.'); return; }
    }
    const file = state.entryMode === "words" ? null : screenshotInput.files?.[0];
    if (state.entryMode !== "words" && (state.hasScreenshot || state.screenshotImage) && !file && !isShopifyFileUrl(state.screenshotUrl)) {
      setError("Please upload the screenshot again before ordering so it can be attached to your print.");
      return;
    }
    if (state.entryMode === "words" && state.hasGiftPhoto && !state.giftPhotoFile) {
      setError("Please upload the original image again before ordering.");
      return;
    }
    if (!ensureComment()) return;
    const isDigital = state.product === "digital";
    if (!isDigital && imagePrintQuality(R.productFor(state.product))?.level === "low" && !document.getElementById("qualityConfirmInput").checked) {
      setError("Please confirm that this image may print blurry at the selected size.");
      document.getElementById("qualityConfirmInput").focus();
      return;
    }
    const selected = selectedVariant();
    const variant = Object.keys(catalogue).length ? selected?.available && selected.id : state.frameColor === 'black' ? shopifyVariants[state.product] : null;
    if (!variant) { setError("This print is not available to order yet."); return; }
    const campaign = new URLSearchParams(location.search).get("utm_campaign") || "";
    const giftCampaign = /^gift_(wedding_anniversary|kids_quotes|business_gifts)$/.test(campaign) ? campaign : "";
    const savedHash = encodeState();
    const savedDesign = JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(savedHash),c=>c.charCodeAt(0))));
    let designUrl = `https://framethiscomment.com/pages/create#${savedHash}`;
    const designProperty = "_Design link";
    const frameColour = colorsFor(state.product).length ? frameColors[state.frameColor][0] : '';
    const artworkStyle = review ? 'Review' : state.style;
    const route = window.Shopify?.routes?.root || '/';
    const request = crypto.randomUUID();
    ordering = true;
    button.disabled = true;
    button.textContent = "Preparing order...";
    clearError();
    let addedKey = "";
    let addAttempted = false;
    try {
      if (!window.FTCCartPrivacy) throw new Error("Please reload the editor before ordering.");
      const data = new FormData();
      data.set("id", String(variant));
      data.set("quantity", "1");
      data.set(`properties[${designProperty}]`, designUrl);
      data.set("properties[_Checkout request]", request);
      data.set("properties[_Fulfilment]", "Render after payment");
      data.set("properties[Artwork style]", artworkStyle);
      if (review) {
        data.set('properties[_Review permission]', 'Confirmed by purchaser');
        data.set('properties[Review layout]', {text:'Review text',combined:'Text + screenshot',screenshot:'Screenshot only'}[state.reviewLayout]);
      }
      if (frameColour) data.set('properties[Frame colour]', frameColour);
      if (selected?.uid) data.set('properties[_Gelato product UID]', selected.uid);
      if (isDigital) data.set("properties[Delivery]", "Clean 2400 x 3000 PNG by email after payment");
      if (G?.byId[state.templateId] && state.entryMode === "words") data.set("properties[Gift template]", G.byId[state.templateId].name);
      if (giftCampaign) data.set("properties[Gift campaign]", giftCampaign);
      if (file) data.set("properties[_Source screenshot]", file, file.name);
      else if (state.entryMode !== 'words' && isShopifyFileUrl(state.screenshotUrl)) data.set('properties[_Source screenshot]',state.screenshotUrl);
      if (state.entryMode === 'words' && state.giftPhotoFile) data.set("properties[_Source image]", state.giftPhotoFile, state.giftPhotoFile.name);
      await window.FTCCartPrivacy.sanitizeCart();
      button.textContent = "Adding to cart...";
      addAttempted = true;
      const addedResponse = await fetch(route + "cart/add.js", { method: "POST", body: data, credentials: "same-origin" });
      const added = await addedResponse.json();
      if (!addedResponse.ok) throw new Error(added.description || "Could not add this print to the cart.");
      addedKey = added.key;
      if (added.properties?.[designProperty] !== designUrl) throw new Error("Shopify did not save the design link. Please try again.");
      if (file && !isShopifyFileUrl(added.properties?.["_Source screenshot"])) {
        throw new Error("The screenshot was not attached. Please check the cart before ordering.");
      }
      if (data.has('properties[_Source image]') && !isShopifyFileUrl(added.properties?.["_Source image"])) {
        throw new Error("The source image was not attached. Please try again.");
      }
      if (file) {
        // Shopify returns the durable original-image URL only after the upload.
        savedDesign.screenshotUrl = added.properties['_Source screenshot'];
        if (screenshotInput.files?.[0] === file) state.screenshotUrl = savedDesign.screenshotUrl;
        designUrl = `https://framethiscomment.com/pages/create#${encodePayload(savedDesign)}`;
        const properties = {...added.properties, [designProperty]:designUrl};
        const changedResponse = await fetch(route + 'cart/change.js', {
          method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({id:addedKey,quantity:1,properties})
        });
        const changed = await changedResponse.json();
        const line = changed.items?.find(item => item.properties?.['_Checkout request'] === request);
        if (line?.key) addedKey = line.key;
        if (!changedResponse.ok || line?.properties?.[designProperty] !== designUrl || line.properties['_Source screenshot'] !== savedDesign.screenshotUrl) throw new Error('Could not save the screenshot in your design. Please try again.');
      }
      const cartResponse = await fetch(route + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ attributes: { __design_url: designUrl, design_url: "", print_url: "", ...(giftCampaign ? { gift_campaign: giftCampaign } : {}) } })
      });
      const cart = await cartResponse.json();
      if (!cartResponse.ok || cart.attributes?.design_url || cart.attributes?.print_url) {
        throw new Error("The design link could not be saved to the order. Please try again.");
      }
      location.href = route + "checkout";
    } catch (error) {
      if (addAttempted) {
        try {
          const current = await fetch(route+'cart.js',{credentials:'same-origin'});
          if (!current.ok) throw new Error('Cart unavailable');
          const cart = await current.json();
          for (const item of cart.items.filter(line=>line.properties?.['_Checkout request']===request)) {
            const removed = await fetch(route+'cart/change.js', {
              method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',
              body:JSON.stringify({id:item.key,quantity:0})
            });
            if (!removed.ok) throw new Error('Cart cleanup failed');
          }
        } catch (_) { error.message += ' Please check your cart before retrying; an incomplete item may remain.'; }
      }
      setError(error.message || "Could not start checkout. Please try again.");
      ordering = false;
      button.disabled = false;
      button.innerHTML = `${icon("shopping-bag")} Order`;
      if (window.lucide) window.lucide.createIcons();
    }
  }
  function downloadPreview() {
    if (!ensureComment()) return;
    const ratio = R.aspectRatio(state.product);
    const canvas = document.createElement("canvas");
    canvas.width = 900;
    canvas.height = Math.round(canvas.width / ratio);
    const context = canvas.getContext("2d");
    if (!context) { setError("Could not create the preview image."); return; }
    drawArtwork(context, renderModel(), canvas.width, canvas.height);
    const label = "FRAME THIS COMMENT  \u00b7  PREVIEW";
    const fontSize = Math.round(canvas.width * .045);
    const rowHeight = Math.round(canvas.width * .22);
    context.save();
    context.translate(canvas.width / 2, canvas.height / 2);
    context.rotate(-Math.PI / 7);
    context.font = `700 ${fontSize}px sans-serif`;
    context.textAlign = "center";
    context.textBaseline = "middle";
    context.lineWidth = Math.max(2, Math.round(fontSize * .08));
    context.strokeStyle = "rgba(255, 255, 255, .48)";
    context.fillStyle = "rgba(24, 29, 31, .32)";
    const span = Math.hypot(canvas.width, canvas.height);
    const columnWidth = Math.round(context.measureText(label).width + canvas.width * .08);
    for (let y = -span; y <= span; y += rowHeight) {
      for (let x = -span; x <= span; x += columnWidth) {
        const offset = Math.round(y / rowHeight) % 2 ? columnWidth / 2 : 0;
        context.strokeText(label, x + offset, y);
        context.fillText(label, x + offset, y);
      }
    }
    context.restore();
    canvas.toBlob((blob) => {
      if (!blob) { setError("Could not create the preview image."); return; }
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `framethiscomment-${state.style}-preview.png`;
      link.click();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    }, "image/png");
  }
  async function exportPrintFile() {
    if (shopifyMode) return;
    if ((state.hasScreenshot || state.style === "screenshot") && !state.screenshotImage) {
      setError("Upload the original screenshot before exporting the print file.");
      return;
    }
    if (state.entryMode === "words" && state.hasGiftPhoto && !state.giftPhotoImage) {
      setError("Upload the original image before exporting the file.");
      return;
    }
    if (!ensureComment()) return;
    try {
      if (G && state.entryMode === "words") await G.ensureFonts();
      await document.fonts.ready;
      const [width, height] = R.exportSize(state.product);
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext("2d");
      if (!context) throw new Error("Could not create the print file.");
      drawArtwork(context, renderModel(), width, height);
      const blob = await canvasBlob(canvas, "image/png");
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `framethiscomment-${state.style}-${state.product}${state.product === "digital" ? "" : "-print"}.png`;
      link.click();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) { setError(error.message || "Could not create the print file."); }
  }
  async function copyDesignLink(button) {
    if (!ensureComment()) return;
    const url = new URL(location.href);
    url.hash = encodeState();
    try {
      await navigator.clipboard.writeText(url.href);
      const original = button.innerHTML;
      button.textContent = "Copied";
      setTimeout(() => { button.innerHTML = original; if (window.lucide) window.lucide.createIcons(); }, 1400);
      if (state.screenshotDataUrl && !state.screenshotUrl) setError("The link carries the text and choices. The screenshot is attached and saved in the order's design link when you order; until then it stays in this browser session.");
    } catch (_) { setError("Copy failed here. Use the address bar to copy this design link."); }
  }

  writeFields();
  if (state.screenshotDataUrl || state.screenshotUrl) {
    document.getElementById("uploadStatus").textContent = "Screenshot loaded";
    document.getElementById("removeScreenshot").hidden = false;
  }
  showStep();
  render();
  if (G) G.ensureFonts().then(scheduleRender).catch(() => {});
  window.addEventListener("resize", () => { placePreview(); scheduleRender(); });
})();
